import * as Api from '@ViewModels';
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../components-v2/Button';
import { Dropdown, DropdownContent, DropdownItem, DropdownTrigger } from '../../../components-v2/Dropdown';
import { THEME } from '../../../components-v2/Theme/theme';
import { PriorityFlagIcon } from '../../../components/svgs/icons/PriorityFlagIcon';
import { PRIORITIES, PRIORITY_LABELS, priorityColor } from '../utils/priority';

interface IProps {
	priority: Api.ActionItemPriority | undefined;
	onChange: (priority: Api.ActionItemPriority) => void;
	disabled?: boolean;
	showLabel?: boolean;
}

export const PriorityFlag: React.FC<IProps> = ({ priority, onChange, disabled, showLabel }) => {
	const effective = priority ?? 'None';
	return (
		<Dropdown>
			<DropdownTrigger
				render={props => (
					<Button
						{...props}
						variant='ghost'
						size={showLabel ? 'sm' : 'icon'}
						disabled={disabled}
						aria-label={`${PRIORITY_LABELS[effective]}. Change priority`}
						styles={[styleSheet.trigger, effective === 'None' && styleSheet.none]}
						onClick={event => {
							event.stopPropagation();
							props.onClick?.(event);
						}}
					>
						<PriorityFlagIcon
							width={14}
							height={14}
							style={{ color: priorityColor(effective) }}
							fill={effective === 'None' ? 'none' : priorityColor(effective)}
						/>
						{showLabel ? <span>{PRIORITY_LABELS[effective]}</span> : null}
					</Button>
				)}
			/>
			<DropdownContent align='end' onClick={event => event.stopPropagation()}>
				{PRIORITIES.map(option => (
					<DropdownItem key={option} onClick={() => onChange(option)}>
						<span className={css(styleSheet.menuItem)}>
							<PriorityFlagIcon
								width={14}
								height={14}
								style={{ color: priorityColor(option) }}
								fill={option === 'None' ? 'none' : priorityColor(option)}
							/>
							{PRIORITY_LABELS[option]}
						</span>
					</DropdownItem>
				))}
			</DropdownContent>
		</Dropdown>
	);
};

const styleSheet = StyleSheet.create({
	trigger: {
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.standard,
		color: THEME.colors.text.light,
	},
	none: {
		opacity: 0.55,
		':hover': {
			opacity: 1,
		},
	},
	menuItem: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
	},
});
